module.exports = __webpack_public_path__ + "static/img/introduce_2.1583a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_2.png
// module id = RM8w
// module chunks = 1